<template>
    <vs-popup class="taste-panel-create-popup" id="popup" title="CUSTOMER BULK ACTION" @close="open = false"
        :active.sync="open" :buttons-hidden="true">
        <vx-card no-shadow subtitle="Selected customer list" cardBorder>
            <vs-table id="wo-list-table" :data="customerList" :sst="true" v-model="selectedCustomers" :multiple="true"
                :selectable="true">
                <template slot="thead">
                    <vs-th width="13%" sort-key="account_number">ACCOUNT NUMBER</vs-th>
                    <vs-th width="14%" sort-key="company_name">COMPANY NAME</vs-th>
                    <vs-th width="10%">ACCOUNT HANDLER</vs-th>
                    <vs-th width="13%">EMAIL</vs-th>
                    <vs-th width="10%">MAIN TELEPHONE</vs-th>
                    <vs-th width="5%" sort-key="currency">CURRENCY</vs-th>
                    <vs-th width="10%" sort-key="status">CUSTOMER ACCOUNT STATUS</vs-th>
                    <vs-th width="9%">CUSTOMER PORTAL STATUS</vs-th>
                    <vs-th width="8%">OTIF TRACKED</vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr v-for="(tr, indextr) in data" :key="indextr" :data="tr" style="cursor: pointer">
                        <vs-td :data="tr.account_number">
                            {{ tr.account_number }}
                        </vs-td>

                        <vs-td :data="tr.company_name">
                            {{ tr.company_name }}
                        </vs-td>
                        <vs-td>
                            {{ tr.account_handler || 'UNALLOCATED' }}
                        </vs-td>
                        <vs-td :data="tr.email">
                            {{ tr.email }}
                        </vs-td>
                        <vs-td>
                            {{ tr.country_code_main_telephone }} {{ tr.main_telephone }}
                        </vs-td>
                        <vs-td>
                            {{ tr.account_currency }}
                        </vs-td>

                        <vs-td>
                            <vs-chip transparent :color="customerStatusColorFactory(tr.status_id)">
                                {{ tr.status.name || 'N/A' }}
                            </vs-chip>
                        </vs-td>
                        <vs-td>
                            <vs-chip transparent :color="tr.is_customer_activated ? 'success' : 'danger'">
                                {{ tr.is_customer_activated ? 'Activated' : 'Suspended' }}
                            </vs-chip>
                        </vs-td>
                        <vs-td>
                            <vs-chip transparent :color="tr.is_otif_tracked ? 'success' : 'danger'">
                                {{ tr.is_otif_tracked ? 'Yes' : 'No' }}
                            </vs-chip>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>
        <vx-card cardBorder>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(onClickBulkAction)" autocomplete="off">

                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                        <ValidationProvider vid="account_handlers" name="account_handlers" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-100 text-bold">New Account Handler</label>
                            <v-select name="account_handlers"
                                v-model="selectedAccountHandlers" :options="account_handlers"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.value" label="name" />
                            <span class="text-danger text-sm">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="flex flex-wrap items-center justify-end mt-8">
                        <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
                        <vs-button @click="resetForm" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
                    </div>

                </form>
            </ValidationObserver>
        </vx-card>
    </vs-popup>
</template>

<script>
import vSelect from 'vue-select'
import Utils from '@/mixins/Utils'
import { mapGetters, mapActions } from 'vuex';
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CustomerRepository = RepositoryFactory.get('customer')

function initialState() {
    return {
        open: false,
        customerList: [],
        selectedCustomers: [],
        selectedAccountHandlers: null,
    }
}


export default {
    name: 'CustomerBulkActionPopUp',
    data() {
        return initialState()
    },
    mixins: [Utils],
    computed: {
        ...mapGetters(['account_handlers'])
    },
    methods: {
        ...mapActions(['fetchAccountHandlers']),
        async openPopup(customerList = [],) {
            try {
                await Object.assign(this.$data, initialState())
                await this.fetchAccountHandlers()
                this.customerList = customerList
                this.selectedCustomers = customerList
                this.$refs.form.reset();
                this.open = true;
            } catch (error) {

            }
        },
        resetForm() {
            this.$refs.form.reset()
            this.$data.form = initialState()
            this.$data.selectedCustomers = []
            this.$data.selectedAccountHandlers = null
        },
        async onClickBulkAction() {
            try {
                this.$vs.loading()
                const customerIds = this.selectedCustomers.map(customer => customer.id)
                const payload = {
                    customer_ids: customerIds,
                    to_account_handler_id: this.selectedAccountHandlers
                }
                const resolve = await CustomerRepository.customerBulkActionAccountHandler(payload)
                this.open = false
                this.$emit('refreshData')
            } catch (e) {

            } finally {
                this.$vs.loading.close()
            }
        },
    },
    components: {
        'v-select': vSelect,
    }

}
</script>
<style scoped>
.taste-panel-create-popup>>>.vs-popup {
    /*min-height: 50% !important;*/
    min-width: 80% !important;
}
</style>